import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { http, INSTAGRAM, scrollToId } from "../lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await http.post("/newsletter", { email });
      toast.success("You're on the list. Next drop hits your inbox first.");
      setEmail("");
    } catch {
      toast.error("Enter a valid email.");
    }
  };
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-black px-5 pb-10 pt-20 md:px-12" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1600px] gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <p className="font-display text-4xl font-black uppercase leading-none md:text-5xl">Get the drop<br />before it drops.</p>
          <form onSubmit={submit} className="mt-8 flex max-w-md border border-white/20 focus-within:border-[#00FF66]">
            <input data-testid="newsletter-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="YOUR@EMAIL.COM" className="flex-1 bg-transparent px-4 py-4 font-mono text-sm uppercase outline-none placeholder:text-zinc-500" />
            <button data-testid="newsletter-submit-btn" className="bg-[#00FF66] px-5 text-black transition-colors hover:bg-white"><ArrowRight className="h-5 w-5" /></button>
          </form>
        </div>
        <div className="grid grid-cols-2 gap-8 font-mono text-xs uppercase tracking-widest text-zinc-400 md:col-span-6">
          <div className="flex flex-col gap-3">
            <span className="text-white">Shop</span>
            <button data-testid="footer-shop-link" onClick={() => scrollToId("shop")} className="text-left hover:text-[#00FF66]">All Tees</button>
            <button data-testid="footer-lookbook-link" onClick={() => scrollToId("lookbook")} className="text-left hover:text-[#00FF66]">Lookbook</button>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-white">Connect</span>
            <a data-testid="footer-instagram-link" href={INSTAGRAM} target="_blank" rel="noreferrer" className="hover:text-[#00FF66]">Instagram @tbrand_111</a>
            <span>Shipping across India</span>
          </div>
        </div>
      </div>
      <p className="pointer-events-none mt-16 select-none text-center font-display text-[24vw] font-black uppercase leading-[0.8] tracking-tighter text-white/[0.06]">T Brand</p>
      <p className="mt-6 text-center font-mono text-xs uppercase tracking-widest text-zinc-400">© 2026 T Brand. All rights reserved.</p>
    </footer>
  );
};
